import IDPsBreakDownIndicator from './IDPsBreakDownIndicator';

export default IDPsBreakDownIndicator;
